<button type="button" class="btn btn-sm btn-primary" (click)=openItemInfoModal()>ADD ITEM</button>

